import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderException } from '../../overview/models/order-exception';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderExceptionsDetailsService {
  constructor(private http: HttpClient) {}

  getOrderExceptionBy(id: string, isArchived: boolean) {
    const url = isArchived ? 'archive/purchaseOrderExceptions' : 'purchaseOrderExceptions';
    return this.http.get<OrderException>(`${environment.apiUrl}/${url}/${id}`);
  }

  watched(orderExceptionId: string, watched: boolean) {
    return this.http.put(`${environment.apiUrl}/purchaseOrderExceptions/${orderExceptionId}/watched`, { watched });
  }
}
